import { languageMap } from ".."

languageMap.keyman = {
	comments: {
		line: "c",
	},
}
